// ╔══════════════════════════════════════════════════════════════════════╗
// ║  DO NOT EDIT — generated from react/_shared/config/clients.json        ║
// ║  by scripts/sync_frontend_config.sh. Edit the registry there, then     ║
// ║  re-run the script. CI verifies this file with --check.                ║
// ║  PUBLIC client identifier (NOT a secret).                              ║
// ╚══════════════════════════════════════════════════════════════════════╝
export const WALLETCONNECT_PROJECT_ID = "2f319e5db32fb642541f2c081e56cf47";
